<template>
    <div :class="{'warning': type === 'countdown'}" class="led-timer">
        <div class="num">{{ m1 }}</div>
        <div class="num">{{ m2 }}</div>
        <div class="colon"></div>
        <div class="num">{{ s1 }}</div>
        <div class="num">{{ s2 }}</div>
    </div>
</template>

<script>

import tool from '@/assets/scripts/tool.js';

export default {
    props: {
        timeInSeconds: {
            type: Number,
            default: 0
        },

        isLock: {
            type: Boolean,
            default: false
        },

        currentShow: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            startTime: 0,
            timerId: 0,
            isShow: false,
            isWarning: false,
            durationString: '',
            timeLeft: 9999,
            totalTimeInSeconds: 0
        };
    },

    computed: {
        m1: function() {
            return this.getChar(0);
        },

        m2: function() {
            return this.getChar(1);
        },

        s1: function() {
            return this.getChar(3);
        },

        s2: function() {
            return this.getChar(4);
        }
    },

    created: function() {
        console.log(this.type)
        this.startTime = Math.floor(Date.now() / 1000);
        
        // if (this.type === 'countup') this.isShow = true;

        if (isNaN(this.timeInSeconds) || this.timeInSeconds < 0) 
            this.totalTimeInSeconds = 0;
        else 
            this.totalTimeInSeconds = this.timeInSeconds;
        
        // 只有明确指定正计时或者倒计时的时候才需要启动计时器，否则不需要启动计时器
        if (this.type === 'countup' || this.type === 'countdown') {
            this.timerId = setInterval(() => {
                let now = Math.floor(Date.now() / 1000);
                if (this.type === 'countup') {
                    this.durationString = tool.formatTime(now - this.startTime);
                } else {
                    this.timeLeft = this.totalTimeInSeconds - (now - this.startTime);
                    this.durationString = tool.formatTime(this.timeLeft);
                    if (this.timeLeft > 3600) {
                        this.isShow = false;
                    } else if (30 < this.timeLeft && this.timeLeft <= 3600) {
                        this.isShow = true;
                    } else if (0 < this.timeLeft && this.timeLeft <= 30) {
                        this.isShow = ! this.isShow;
                        this.isWarning = true;
                    } else {
                        this.isShow = false;
                        clearInterval(this.timerId);
                        this.timerId = 0;
                    }
                }
            }, 500);
        }
    },

    mounted: function() {
        console.log('timer');
    },

    destroyed: function() {
        clearInterval(this.timerId);
        this.timerId = 0;
    },

    methods: {
        getChar: function(index) {
            if (! this.durationString || this.durationString.length < 5) return '-';
            return this.durationString.charAt(index);
        }
    }
};
</script>

<style scoped>
    .led-timer {
        height: 40px;
        text-align: left;
    }

    .led-timer .num {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        vertical-align: middle;
        margin-left: 10px;
        background-color: #252525;
        color: #ffffff;
        font-size: 30px;
        border-radius: 4px;
    }

    .led-timer .num:first-child {
        margin-left: 0;
    }

    .led-timer.warning .num {
        background-color: #C83737;
    }

    .led-timer .colon {
        display: inline-block;
        width: 4px;
        height: 14px;
        margin: 8px 0 0 10px;
        background-image: url('../assets/image/colon.png');
        background-size: 4px 14px;
        background-repeat: no-repeat;
    }
</style>


